import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "../../../services/userService/user.service";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import * as CryptoJS from "crypto-js";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

@Component({
  selector: "app-addcompany",
  templateUrl: "./addcompany.component.html",
  styleUrls: ["./addcompany.component.css"],
})
export class AddcompanyComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  multiClick = false;
  showcompany: any;
  showstatus: any;
  parent: any;
  show: any;
  showDeliveryArray: any = [];
  value: any;
  userid: any;
  CountryList: any = [];
  dropdownCountry: any = {};
  dropdownState: any = {};
  dropdownCity;
  any = {};
  cityArray: any = [];
  cityList: any = [];
  countryListArray: any = [];
  dropdownSetting0: any = {};
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  shownameArray: any = [];
  shortname: any;
  shortcountryname: any;
  dropdownSetting4: any = {};
  dropdownSetting9: any = {};
  dropdownSetting10: any = {};
  dropdownSetting11: any = {};
  dropdownDesignation: any = {};
  CompanyId: any;
  selectedItems = [];
  id: any;
  dropdownSetting6: any = {};
  dropdownSetting3: any = {};
  dropdownSetting8: any = {};
  selectedType: any = {};
  selectedTypeId: any = {};
  showtypeArray: any = [];
  businessStreamArray: any = [];
  dropdownSetting5: any = {};
  showAccountArray: any = [];
  dropdownSetting7: any = {};
  showcategoryArray: any = [];
  showPaymentArray: any = [];
  showStatusArray: any = [];
  showProfileArray: any = [];
  createdCompanyId: any;
  createdCompanyIds: any;
  encryptCompanyId: any;
  maxlength: string | number | null;

  CmpNameId: Observable<string[]>;
  optionsCmp: string[] = [];
  permission: any;
  userRId: any;

  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private UserService: UserService
  ) {}

  mobnumPattern = "^((\\+91-?)|0)?[0-9]{6,15}$";
  landlinePattern = "^((\\+91-?)|0)?[0-9]{6,15}$";
  emailPattern = new RegExp(
    /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/
  );
  reg = "^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";
  companyPattern = "^[a-zA-Z0-9-_ @./#&+-]+$";

  ngOnInit(): void {
    this.userid = localStorage.getItem("CompanyId");
    let userid = localStorage.getItem("userId");
    this.userid = this.UserService.decryptData(userid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Company_Add != 1 && this.userRId != 1) {
      this.toastrService.error("You do not have permission");
      this.router.navigate(["/profile"]);
    }

    this.getCountries();
    this.getname();
    this.gettype();
    this.getbusiness();
    this.getAccount();
    this.getcategory();
    this.getPayment();
    this.getStatus();
    this.getProfile();
    this.getDelivery();

    this.registerForm = this.formBuilder.group({
      CompanyName: ["", [Validators.required]],
      ParentCompany: [""],
      CompanyTypeId: ["", Validators.required],
      CompanyProfileId: ["", Validators.required],
      BusinessStreamId: ["", Validators.required],
      AccountManager: ["", Validators.required],
      CategoryId: ["", Validators.required],
      Mobile: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(/^\+\d{6,15}$/),
        ],
      ],
      Landline: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(/^\+\d{6,15}$/),
        ],
      ],
      CountryId: ["", Validators.required],
      PaymentHistoryId: [""],
      FinancialStatusId: [""],
      SupplierDeliveryHistoryId: [""],
      KeyAccounts: [""],
      ClientTime: [""],
      StateId: [""],
      CityId: [""],
      MapLocation: ["", [Validators.pattern(this.reg)]],
      Fax: ["", [Validators.minLength(6), Validators.pattern(/^\+\d{6,15}$/)]],
      Email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      Website: [
        "",
        Validators.pattern(
          /^((ftp|http|https):\/\/)?[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,63}(\/[\w\-\.~:@?%&+\/#=]*)?$/
        ),
      ],
      AddressLine1: [""],
      AddressLine2: [""],
      AddressLine3: [""],
      PostalCode: [""],
      Remarks: [""],
      CreatedBy: this.userid,
    });

    this.dropdownSetting0 = {
      singleSelection: true,
      text: "Select Country",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownSetting1 = {
      singleSelection: true,
      text: "Select State",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting2 = {
      singleSelection: true,
      text: "Select City",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "myclass custom-class",
      lazyLoading: false,
      badgeShowLimit: 1,
    };
    this.dropdownSetting3 = {
      singleSelection: false,
      text: "Company Type",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting4 = {
      singleSelection: false,
      text: "Business Stream",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting5 = {
      singleSelection: true,
      text: "Account Manager",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownSetting6 = {
      singleSelection: true,
      text: "Parent Company",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting7 = {
      singleSelection: true,
      text: "Category",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting8 = {
      singleSelection: true,
      text: "Payment History",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      lazyLoading: false,
      badgeShowLimit: 1,
    };
    this.dropdownSetting9 = {
      singleSelection: true,
      text: "Financial Status",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting10 = {
      singleSelection: true,
      text: "Company Profile",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting11 = {
      singleSelection: true,
      text: "Supplier Deliver History",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
  }

  CmpSearchFun(event) {
    let value1 = event.target.value;
    this.CmpNameId = this.registerForm.controls[
      "CompanyName"
    ].valueChanges.pipe(
      startWith(""),
      map((value: string) => this.filterIqr(value1 || ""))
    );
  }
  private filterIqr(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsCmp.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  get f() {
    return this.registerForm.controls;
  }

  showname: any = [];
  getname() {
    let data = {};
    this.UserService.GetAllCompanyName(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.shownameArray = res;
        for (const dataItem of this.shownameArray["Data"]) {
          this.showname.push({
            id: dataItem["CompanyId"],
            itemName: dataItem["CompanyName"],
          });
          this.optionsCmp.push(dataItem["CompanyName"]);
        }
      } else {
        this.shownameArray = [];
        this.optionsCmp = [];
      }
    });
  }
  selectedname: any = [];
  selectedName: any;
  selectedNameId: any;
  onNameSelect(item: any) {
    this.selectedName = "";
    this.selectedNameId = "";
    this.selectedname.forEach((element) => {
      this.selectedName += element["itemName"];
      this.selectedNameId += element["id"];
    });
  }

  showtype: any = [];
  gettype() {
    let data = {};
    this.UserService.getcompanytype(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showtypeArray = res;
        for (const dataItem of this.showtypeArray["Data"]) {
          this.showtype.push({
            id: dataItem["Id"],
            itemName: dataItem["CompanyType"],
          });
        }
      } else {
        this.showtypeArray = [];
      }
    });
  }

  selectedtype: any = [];
  onTypeSelect(item: any) {
    this.selectedType = "";
    this.selectedTypeId = "";
    this.selectedtype.forEach((element) => {
      this.selectedType += element["itemName"] + ", ";
      this.selectedTypeId += element["id"] + ", ";
    });
  }

  businessStream: any = [];
  getbusiness() {
    let data = {};
    this.UserService.GetBusinessStream(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.businessStreamArray = res;
        for (const dataItem of this.businessStreamArray["Data"]) {
          this.businessStream.push({
            id: dataItem["BSID"],
            itemName: dataItem["BusinessStream"],
          });
        }
      } else {
        this.businessStreamArray = [];
      }
    });
  }
  selectedBusiness: any = [];
  selectedBusinessName: string = "";
  selectedBusinessNameId: string = "";
  onBusinessSelect(item: any) {
    this.selectedBusinessName = "";
    this.selectedBusinessNameId = "";
    this.selectedBusiness.forEach((element) => {
      this.selectedBusinessName += element["itemName"] + ", ";
      this.selectedBusinessNameId += element["id"] + ", ";
    });
  }

  showprofile: any = [];
  getProfile() {
    let data = {};
    this.UserService.GetCompanyProfile(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProfileArray = res;
        for (const profile of this.showProfileArray["Data"]) {
          this.showprofile.push({
            id: profile["CompanyProfileId"],
            itemName: profile["Name"],
          });
        }
      } else {
        this.showProfileArray = [];
      }
    });
  }
  selectedprofile: any = [];
  selectedProfile: string = "";
  selectedProfileId: string = "";
  onProfileSelect(item: any) {
    this.selectedProfile = "";
    this.selectedProfileId = "";
    this.selectedprofile.forEach((element) => {
      this.selectedProfile += element["itemName"];
      this.selectedProfileId += element["id"];
    });
  }

  showdelivery: any = [];
  getDelivery() {
    let data = {};
    this.UserService.GetSupplierDeliveryHistory(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showDeliveryArray = res;
        for (const deliveryItem of this.showDeliveryArray["Data"]) {
          this.showdelivery.push({
            id: deliveryItem["SupplierDeliveryHistoryId"],
            itemName: deliveryItem["Name"],
          });
        }
      } else {
        this.showDeliveryArray = [];
      }
    });
  }
  selecteddelivery: any = [];
  selectedDelivery: string = "";
  selectedDeliveryId: string = "";
  onDeliverySelect(item: any) {
    this.selectedDelivery = "";
    this.selectedDeliveryId = "";
    this.selecteddelivery.forEach((element) => {
      this.selectedDelivery += element["itemName"];
      this.selectedDeliveryId += element["id"];
    });
  }

  showaccount: any = [];
  getAccount() {
    let data = {};
    this.UserService.GetAccountManager(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showAccountArray = res;
        for (const accountItem of this.showAccountArray["Data"]) {
          this.showaccount.push({
            id: accountItem["UserId"],
            itemName: `${accountItem["UserName"]}(${accountItem["Email"]})${accountItem["EmployeeId"]}`,
          });
        }
      } else {
        this.showAccountArray = [];
      }
    });
  }
  selectedaccount: any = [];
  selectedAccount: string = "";
  selectedAccountId: string = "";
  onAccountSelect(item: any) {
    this.selectedAccount = "";
    this.selectedAccountId = "";
    this.selectedaccount.forEach((element) => {
      this.selectedAccount += element["itemName"];
      this.selectedAccountId += element["id"];
    });
  }

  status: any = [];
  getStatus() {
    let data = {};
    this.UserService.GetFinancialStatus(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showStatusArray = res;
        for (const statusItem of this.showStatusArray["Data"]) {
          this.status.push({
            id: statusItem["Id"],
            itemName: statusItem["Description"],
          });
        }
      } else {
        this.showStatusArray = [];
      }
    });
  }
  selectedstatus: any = [];
  selectedStatus: string = "";
  selectedStatusId: string = "";
  onStatusSelect(item: any) {
    this.selectedStatus = "";
    this.selectedStatusId = "";
    this.selectedstatus.forEach((element) => {
      this.selectedStatus += element["itemName"];
      this.selectedStatusId += element["id"];
    });
  }

  showpayment: any = [];
  getPayment() {
    let data = {};
    this.UserService.GetPaymentHistory(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showPaymentArray = res;
        for (const paymentItem of this.showPaymentArray["Data"]) {
          this.showpayment.push({
            id: paymentItem["Id"],
            itemName: paymentItem["Name"],
          });
        }
      } else {
        this.showPaymentArray = [];
      }
    });
  }
  selectedpayment: any = [];
  selectedPayment: string = "";
  selectedPaymentId: string = "";
  onPaymentSelect(item: any) {
    this.selectedPayment = "";
    this.selectedPaymentId = "";
    this.selectedpayment.forEach((element) => {
      this.selectedPayment += element["itemName"];
      this.selectedPaymentId += element["id"];
    });
  }

  getCountries() {
    let data = {};
    this.UserService.GetCountries(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.countryListArray = res;
        this.shortcountryname = res["Data"];
        this.shortname = res["Data"]["iso2"];
        for (const countryItem of this.countryListArray["Data"]) {
          this.CountryList.push({
            id: countryItem["Id"],
            itemName: countryItem["Name"],
            shortname: countryItem["iso2"],
          });
        }
      } else {
        this.countryListArray = [];
      }
    });
  }
  selectedCountryName: string = "";
  selectedCountryId: string = "";
  selectedCountry: any = [];
  onCountrySelect(item: any) {
    this.selectedCountryName = "";
    this.selectedCountryId = "";
    this.selectedCountry.forEach((element) => {
      this.selectedCountryName = element["itemName"];
      this.selectedCountryId = element["id"];
    });
    this.stateList = [];
    this.selectedState = [];
    this.cityList = [];
    this.selectedCity = [];
    this.getStatesByCountryId(this.selectedCountryId);
  }
  stateArray: any = [];

  getStatesByCountryId(id) {
    let data = {
      CountryId: id,
    };
    this.UserService.GetStatesByCountryId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.stateArray = res;
        for (const dataItem of this.stateArray["Data"]) {
          this.stateList.push({
            id: dataItem["Id"],
            itemName: dataItem["Name"],
          });
        }
      } else {
        this.stateList = [];
      }
    });
  }
  stateList: any = [];
  selectedStateName: string = "";
  selectedStateId: string = "";
  selectedState: any = [];
  onStateSelect(item: any) {
    this.selectedStateName = "";
    this.selectedStateId = "";
    this.selectedState.forEach((element) => {
      this.selectedStateName = element["itemName"];
      this.selectedStateId = element["id"];
    });
    this.cityList = [];
    this.selectedCity = [];
    this.getCitiesByStateId(this.selectedStateId);
  }
  getCitiesByStateId(id) {
    let data = {
      StateId: id,
    };
    this.UserService.GetCitiesByStateId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.cityArray = res;
        for (const dataItem of this.cityArray["Data"]) {
          this.cityList.push({
            id: dataItem["Id"],
            itemName: dataItem["Name"],
          });
        }
      } else {
        this.cityList = [];
      }
    });
  }
  selectedCityName: string = "";
  selectedCityId: string = "";
  selectedCity: any = [];
  onCitySelect(item: any) {
    this.selectedCityName = "";
    this.selectedCityId = "";
    this.selectedCity.forEach((element) => {
      this.selectedCityName = element["itemName"];
      this.selectedCityId = element["id"];
    });
  }

  showcategory: any = [];
  getcategory() {
    let data = {};
    this.UserService.GetCategory(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showcategoryArray = res;
        for (const dataItem of this.showcategoryArray["Data"]) {
          this.showcategory.push({
            id: dataItem["CategoryID"],
            itemName: `${dataItem["CategoryName"]} (${dataItem["CategoryDescription"]})`,
          });
        }
      } else {
        this.showcategoryArray = [];
      }
    });
  }
  selectedcategory: any = [];
  selectedCategory: string = "";
  selectedCategoryId: string = "";
  onCategorySelect(item: any) {
    this.selectedCategory = "";
    this.selectedCategoryId = "";
    this.selectedcategory.forEach((element) => {
      this.selectedCategory += element["itemName"];
      this.selectedCategoryId += element["id"];
    });
  }

  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  onSubmit() {
    this.submitted = true;
    if (this.registerForm.valid) {
      if (this.selectedStateId == "") {
        this.selectedStateId = "0";
      }
      if (this.selectedCityId == "") {
        this.selectedCityId = "0";
      }
      if (this.selectedPaymentId == "") {
        this.selectedPaymentId = "0";
      }
      if (this.selectedStatusId == "") {
        this.selectedStatusId = "0";
      }
      if (this.selectedDeliveryId == "") {
        this.selectedDeliveryId = "0";
      }
      let data = {
        CompanyName: this.registerForm.value.CompanyName,
        ParentCompany: this.selectedNameId,
        CompanyTypeId: this.selectedTypeId,
        CompanyProfileId: this.selectedProfileId,
        BusinessStreamId: this.selectedBusinessNameId,
        AccountManager: this.selectedAccountId,
        CategoryId: this.selectedCategoryId,
        PaymentHistoryId: this.selectedPaymentId,
        FinancialStatusId: this.selectedStatusId,
        SupplierDeliveryHistoryId: this.selectedDeliveryId,
        KeyAccounts: this.registerForm.value.KeyAccounts,
        ClientTime: this.registerForm.value.ClientTime,
        CountryId: this.selectedCountryId,
        StateId: this.selectedStateId,
        CityId: this.selectedCityId,
        MapLocation: this.registerForm.value.MapLocation,
        Landline: this.registerForm.value.Landline,
        Mobile: this.registerForm.value.Mobile,
        Fax: this.registerForm.value.Fax,
        Email: this.registerForm.value.Email,
        Website: this.registerForm.value.Website,
        AddressLine1: this.registerForm.value.AddressLine1,
        AddressLine2: this.registerForm.value.AddressLine2,
        AddressLine3: this.registerForm.value.AddressLine3,
        PostalCode: this.registerForm.value.PostalCode,
        Remarks: this.registerForm.value.Remarks,
        CreatedBy: this.id,
      };
      if (this.registerForm.valid) {
        this.multiClick = true;
        this.spinner.show();
        this.UserService.CompanySubmit(data).subscribe((res) => {
          if (res["result"] == "success") {
            this.spinner.hide();
            this.toastrService.success(res["Msg"]);
            let CompanyId = res["Data"]["CompnayId"];
            let encryptcompanyid = this.encryptData(CompanyId);
            this.createdCompanyId = localStorage.setItem(
              "createdCompanyId",
              this.encryptCompanyId
            );
            this.router.navigate(["/company/editcompany", encryptcompanyid]);
          } else if (res["result"] == "Failed") {
            this.toastrService.error(res["Msg"]);
            this.spinner.hide();
          } else {
            this.toastrService.error(res["Message"]);
            this.spinner.hide();
          }
          this.submitted = false;
          this.multiClick = false;
        });
      }
    }
  }

  encryptData(data) {
    try {
      if (data) {
        return CryptoJS.AES.encrypt(
          JSON.stringify(data),
          "1234509876encryptdecrypt1234567890"
        ).toString();
      }
    } catch (e) {}
  }
  //End encrypt Data(n)

  decryptData(data) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        data,
        "1234509876encryptdecrypt1234567890"
      );
      if (bytes.toString()) {
        if (CryptoJS.enc.Utf8) {
          return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
      }
      if (data) {
        return data;
      }
    } catch (e) {}
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }
}
